export default __webpack_public_path__ + "static/recent-work-3-495c1d0d64c9baadcf3fe866fdbdf766.png";